import {
  Tv, Tv2, Box, Flame, Smartphone, Apple, Laptop, Cast, Gamepad2,
  Play, Sparkles, HelpCircle,
} from "lucide-react";

const MAP = { Tv, Tv2, Box, Flame, Smartphone, Apple, Laptop, Cast, Gamepad2, Play, Sparkles };

export function Icon({ name, ...props }) {
  const Cmp = MAP[name] || HelpCircle;
  return <Cmp {...props} />;
}
